import { cn } from '@/lib/utils';

type Props = {
    up?: boolean | null;
    className?: string;
};

export const DeltaTriangle: React.FC<Props> = ({ up, className = '' }) => {
    if (up === undefined || up === null) return null;
    if (up) {
        return (
            <span
                className={cn(
                    'ml-1 h-0 w-0 border-b-[7px] border-l-[5px] border-r-[5px] border-b-emerald-500 border-l-transparent border-r-transparent',
                    className,
                )}
            />
        );
    } else {
        return (
            <div
                className={cn(
                    'ml-1 h-0 w-0 border-l-[5px] border-r-[5px] border-t-[7px] border-l-transparent border-r-transparent border-t-red-500',
                    className,
                )}
            />
        );
    }
};
